import { Fragment } from 'react';

import {
  UnpaidInvoicesDialog,
  ActiveSolutionsDialog,
  DiscountRequestDialog,
  NoActiveSolutionsDialog,
  CancellationSuccessDialog,
  KeepPlanDialog,
} from './ui';

type Props = {
  refetch: () => void;
};

const BillingCancellationPlanContainer = ({ refetch }: Props) => {
  return (
    <Fragment>
      <UnpaidInvoicesDialog />
      <ActiveSolutionsDialog />
      <NoActiveSolutionsDialog />
      <DiscountRequestDialog refetch={refetch} />
      <CancellationSuccessDialog refetch={refetch} />
      <KeepPlanDialog />
    </Fragment>
  );
};

export default BillingCancellationPlanContainer;
